import React from 'react';
import { Text, Skeleton } from '@/components/ui';
import { formatFileSize } from '@/utils/fileUtils';

interface FileSizeCellProps {
  value?: unknown;
  bytes?: number;
  render?: () => React.ReactNode;
}

function FileSizeCell({
  value,
  bytes,
  render,
}: FileSizeCellProps) {
  if (render) {
    return <>{render()}</>;
  }

  // Extract bytes from value if bytes prop is not provided
  const sizeBytes = bytes !== undefined ? bytes : (value as number);

  if (sizeBytes === null || sizeBytes === undefined || isNaN(Number(sizeBytes))) {
    return (
      <Text size="2" color="gray">
        —
      </Text>
    );
  }

  const formattedSize = formatFileSize(Number(sizeBytes));

  return (
    <Text size="2" className="data-cell__file-size">
      {formattedSize}
    </Text>
  );
}

export function FileSizeCellSkeleton() {
  return (
    <Skeleton style={{ width: '80px', height: '16px', borderRadius: '4px' }} />
  );
}

export default FileSizeCell;

